import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "@ui/wrapper";
import BoxIcon from "@components/box-icon/layout-03";
import SectionTitle from "@ui/section-title";
import { ItemType, SectionTitleType } from "@utils/types";
import { SectionWrap, BoxWrap, SubTitleWrap } from "./style";
import Image from "@ui/image";

const WhatsNewArea = ({ data, space, hash }) => {
    const mydiv = useRef(null);
    useEffect(() => {
        const h = window.outerHeight - window.innerHeight;
        switch (hash) {
            case "#sensor":
                if (window.document.documentElement.scrollTop == 0) {
                    window.scrollTo({
                        top:
                            mydiv.current.childNodes[0].getBoundingClientRect()
                                .top -
                            76 -
                            h,
                        behavior: "smooth",
                    });
                } else {
                    const he =
                        window.document.documentElement.scrollTop +
                        mydiv.current.childNodes[0].getBoundingClientRect().top;
                    window.scrollTo({ top: he - h, behavior: "smooth" });
                }
                break;
            case "#control":
                if (window.document.documentElement.scrollTop == 0) {
                    window.scrollTo({
                        top:
                            mydiv.current.childNodes[1].getBoundingClientRect()
                                .top -
                            76 -
                            h,
                        behavior: "smooth",
                    });
                } else {
                    const he =
                        window.document.documentElement.scrollTop +
                        mydiv.current.childNodes[1].getBoundingClientRect().top;
                    window.scrollTo({ top: he - h, behavior: "smooth" });
                }
                break;
            case "#gateway":
                if (window.document.documentElement.scrollTop == 0) {
                    window.scrollTo({
                        top:
                            mydiv.current.childNodes[2].getBoundingClientRect()
                                .top -
                            76 -
                            h,
                        behavior: "smooth",
                    });
                } else {
                    const he =
                        window.document.documentElement.scrollTop +
                        mydiv.current.childNodes[2].getBoundingClientRect().top;
                    window.scrollTo({ top: he - h, behavior: "smooth" });
                }
                break;
            case "#edge-computing":
                if (window.document.documentElement.scrollTop == 0) {
                    window.scrollTo({
                        top:
                            mydiv.current.childNodes[3].getBoundingClientRect()
                                .top -
                            76 -
                            h,
                        behavior: "smooth",
                    });
                } else {
                    const he =
                        window.document.documentElement.scrollTop +
                        mydiv.current.childNodes[3].getBoundingClientRect().top;
                    window.scrollTo({ top: he - h, behavior: "smooth" });
                }
                break;
        }
    }, []);
    return (
        <SectionWrap $space={space}>
            <Container>
                <SubTitleWrap>
                    打通<span>物与人</span>，<span>物与物</span>的关系
                </SubTitleWrap>
                {data?.section_title && (
                    <SectionTitle mb="20px" {...data.section_title} />
                )}
                <div ref={mydiv}>
                    {data?.items?.map((item, idx) => (
                        <BoxWrap key={idx + ""} id={hash}>
                            <Row>
                                <Col lg={7} md={12}>
                                    <BoxIcon
                                        key={item.id}
                                        icon={item.images?.[0]}
                                        title={item.title}
                                        desc={item.description}
                                        list={item.designation}
                                    />
                                </Col>
                                <Col lg={5} md={12}>
                                    <Image src={item.images[1]?.src} />
                                </Col>
                            </Row>
                        </BoxWrap>
                    ))}
                </div>
            </Container>
        </SectionWrap>
    );
};

WhatsNewArea.propTypes = {
    data: PropTypes.shape({
        section_title: PropTypes.shape(SectionTitleType),
        items: PropTypes.arrayOf(PropTypes.shape(ItemType)),
    }),
    space: PropTypes.oneOf([1, 2]),
    title: PropTypes.string,
};

WhatsNewArea.defaultProps = {
    space: 1,
};

export default WhatsNewArea;
